import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento_companyshipping-module"
    }}>{`Magento_CompanyShipping module`}</h1>
    <p>{`The Magento_CompanyShipping module allows a merchant to configure which shipping methods are available for B2B companies.`}</p>
    <p>{`In Admin, the CompanyShipping module adds an additional panel (on the Company profile page and on the B2B Features page) where a merchant configures shipping methods for companies. Shipping methods can be configured on the company level.`}</p>
    <h2 {...{
      "id": "installation-details"
    }}>{`Installation details`}</h2>
    <p>{`The module has a dependency on the Magento_Company module, which must be installed and enabled first. This module does not create any backward incompatible changes. It can be deactivated and uninstalled at any time.`}</p>
    <h2 {...{
      "id": "structure"
    }}>{`Structure`}</h2>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/build/component-file-structure/"
      }}>{`Learn about a typical file structure for a Magento 2 module`}</a>{`.`}</p>
    <h2 {...{
      "id": "extensibility"
    }}>{`Extensibility`}</h2>
    <p>{`Extension developers can interact with the Magento_CompanyShipping module. For more information about the Magento extension mechanism, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/plugins/"
      }}>{`Magento plug-ins`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/dependency-injection/"
      }}>{`The Magento dependency injection mechanism`}</a>{` enables you to override the functionality of the Magento_CompanyShipping module.`}</p>
    <h3 {...{
      "id": "layouts"
    }}>{`Layouts`}</h3>
    <p>{`You can extend and override layouts in the `}<inlineCode parentName="p">{`Magento\\CompanyShipping\\view\\frontend\\layout`}</inlineCode>{` directory.`}</p>
    <p>{`For more information about layouts, see the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/guide/layouts/"
      }}>{`Layout documentation`}</a>{`.`}</p>
    <h3 {...{
      "id": "ui-components"
    }}>{`UI components`}</h3>
    <p>{`The following directory contains extensible UI components:`}</p>
    {
      /* Should the description for the following directory be "company profile" or "company shipping methods"? */
    }
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Magento\\CompanyShipping\\view\\frontend\\ui_component`}</inlineCode>{` - company form`}</li>
    </ul>
    <p>{`For more information, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/ui-components/components/form/"
      }}>{`UI Form Component`}</a>{`.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 1.5.1.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      